import { useCertificate } from "@root/hooks/usecertificate";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {};

const CertificateContext = createContext<any>(defaultState);

interface CertificateProviderProps {
  children: ReactNode;
}

export const CertificateProvider: React.FC<CertificateProviderProps> = ({
  children,
}) => {
  const data = useCertificate();
  return (
    <CertificateContext.Provider value={data}>
      {children}
    </CertificateContext.Provider>
  );
};

export const useCertificateContext = () => {
  return useContext(CertificateContext);
};
